<template>
    <div class="pb-1">
        <h3 class="mb-3 kova-text">Overview of Your Career Profile</h3>
        <fullname :overview="true"></fullname>

        <speciality :overview="true"></speciality>

        <experience :overview="true"></experience>

        <other-devs :overview="true"></other-devs>

        <div class="container-fluid px-0 px-md-4 mx-auto mb-5 mt-5">
            <div class="col text-center">
                <button class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded mr-3" v-on:click="$router.back()">
                    Back
                </button>
                <button class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click.prevent="submitProfile">
                    Submit
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Fullname from './Fullname.vue';
import Experience from './Experience.vue';
import Speciality from './Speciality';
import OtherDevs from './OtherDevs.vue';
import api from '../../api';

export default {
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.checkSignupData();
        });
    },
    components: {
        Fullname,
        Experience,
        Speciality,
        OtherDevs,
    },
    data: () => ({
        submit: false,
        count: 0,
    }),
    methods: {
        submitProfile() {
            const vm = this;
            const {
                core_techstack,
                projects_completed_links,
                speciality,
                english_proficiency,
                specializations,

                core_techstack_experience,
                other_core_techstacks,
                other_core_techstack_projects,
                other_core_techstack_project_count,
                work_rate,
                github_link,
                portfolio_links,

                work_experience,
                remote_projects_links,
                company,
                education,

                country,
                project_leader,
                about_me,
                city,
                projects_led_count,
                projects_led,
            } = vm.$store.state.talent.talentData;
            const error = !speciality ? 'Select your speciality' : !core_techstack ? 'Enter your core tech stack' : '';

            if (error.length) {
                this.showError('', error);
                return;
            }

            const isUIUXProduct = speciality.includes('UI') || speciality.includes('Product');

            const companyEmpty = company
                .map(key => {
                    const { organization, Organization, Role, role, Location, location, From, from, To, to } = key;

                    return !(organization || Organization) ||
                        !(role || Role) ||
                        !(location || Location) ||
                        !(from || From) ||
                        !(to || To)
                        ? 1
                        : 0;
                })
                .reduce((a, b) => a + b, 0);
            const educationEmpty = education
                .map(key => {
                    const { Institution, institution, Course, course, Location, location, From, from, to, To } = key;

                    return !(institution || Institution) ||
                        !(location || Location) ||
                        !(from || From) ||
                        !(to || To) ||
                        !(course || Course)
                        ? 1
                        : 0;
                })
                .reduce((a, b) => a + b, 0);

            const error2 = !core_techstack_experience
                ? 'Select the years of experience with your core tech stack'
                : !other_core_techstacks.length
                ? 'Enter other tech stacks'
                : other_core_techstack_projects.length !== other_core_techstack_project_count
                ? 'Enter the links to all the projects you did'
                : !specializations.length
                ? 'Select at least one area of specialization'
                : !github_link && !portfolio_links.length
                ? `Enter the link to your ${isUIUXProduct ? 'portfolio' : 'GitHub'}`
                : github_link && !github_link.includes('github.com/')
                ? `Enter the correct link to your GitHub`
                : education.length && educationEmpty > 0
                ? `Please fill in all the details in education experience`
                : company.length && companyEmpty > 0
                ? `Please fill in all the details in company experience`
                : '';

            if (error2.length) {
                this.showError('', error2);
                return;
            }

            const error4 = !about_me
                ? 'Write a brief introduction about yourself'
                : project_leader && !projects_led_count
                ? "Enter the number of projects you've built as a team leader"
                : projects_led_count && projects_led.length !== projects_led_count
                ? 'Please enter all the links to the projects'
                : !work_rate
                ? 'Pick your hourly rate'
                : !country
                ? 'Please select a country'
                : !city
                ? 'Please select a city'
                : '';

            if (error4.length) {
                this.showError('', error4);
                return;
            }

            const formattedCompany = company.map(key => {
                const { ID, id, organization, Organization, Role, role, Location, location, From, from, To, to } = key;
                return {
                    id: ID || id,
                    organization: Organization || organization,
                    role: Role || role,
                    location: Location || location,
                    from: From || from,
                    to: To || to,
                };
            });

            const formattedEducation = education.map(key => {
                const {
                    id,
                    ID,
                    Institution,
                    institution,
                    Course,
                    course,
                    Location,
                    location,
                    From,
                    from,
                    to,
                    To,
                } = key;
                return {
                    id: ID || id,
                    institution: Institution || institution,
                    course: Course || course,
                    location: Location || location,
                    from: From || from,
                    to: To || to,
                };
            });

            const payload = {
                core_techstack: core_techstack.toString(),
                projects_completed_links,
                speciality,
                english_proficiency,
                specializations,

                core_techstack_experience,
                other_core_techstacks,
                other_core_techstack_projects,
                other_core_techstack_project_count,
                work_rate,
                github_link,
                portfolio_links,

                work_experience,
                remote_projects_links,
                company: formattedCompany,
                education: formattedEducation,

                country,
                project_leader: project_leader || false,
                about_me,
                city,
                projects_led_count,
                projects_led,
            };

            // console.log({ payload });
            // return;

            this.updateProfile(payload);
        },
        async updateProfile(data) {
            this.$store.commit('setLoader', true);
            const token = localStorage.getItem('token');

            try {
                const res = await api({
                    url: `/talents/profiles`,
                    method: 'put',
                    data,
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (res.status == 200) {
                    this.showToast('Profile updated!');
                    this.$router.push('/profile');
                    this.$store.commit('setLoader', false);
                }
            } catch (err) {
                this.catchErrors(err);
            }
        },
    },
};
</script>

<style scoped>
h3.kova-text {
    font-size: 20px;
}
</style>
